"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refresh = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("./utils");
const refresh = async (refreshToken, accessToken) => {
    try {
        const { data } = await axios_1.default.post('/api/auth/refresh', {
            refreshToken,
            accessToken,
        });
        if (data?.redirectUrl) {
            (0, utils_1.removeLocalStorageItems)();
            // @ts-ignore
            window.location = data.redirectUrl;
        }
        if (data.accessToken) {
            localStorage.setItem('expiresIn', data.expiresIn);
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);
        }
    }
    catch (err) {
        if (err.status === 500) {
            throw new Error("Couldn't fetch refresh token");
        }
        else {
            throw err;
        }
    }
};
exports.refresh = refresh;
